<script>
    import { FlowRouter } from "meteor/ostrio:flow-router-extra";
    import { Meteor } from "meteor/meteor";
    import { Tracker } from "meteor/tracker";
    import { onMount } from "svelte";

    let userId = $state(null);

    onMount(() => {
        const computation = Tracker.autorun(() => {
            userId = Meteor.userId();
        });

        return () => computation.stop();
    });
</script>

<footer class="site-footer">
    {#if userId}
        <button
            type="button"
            class="footer-settings"
            onclick={() => FlowRouter.go("/mgmt/settings")}
        >
            Settings
        </button>
    {/if}
    <div class="footer-inner">
        <p class="footer-line">3700 Portage Ave, Winnipeg MB</p>
        <p class="footer-line">
            Email: <a href="mailto:vgoauto@gmail.com">vgoauto@gmail.com</a>
        </p>
        <p class="footer-line">
            Tel: <a href="tel:+12042966886">204-296-6886</a>
        </p>
        <p class="footer-line">Fax: 204-615-7431</p>
        <p class="footer-brand">VGO Auto Financing</p>
    </div>
</footer>
